import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appTooltip]',
})
export class TooltipDirective {
  @Input('appTooltip') tooltipText!: string;
  @Input() isExpanded!: boolean; // Inject isExpanded variable

  tooltipElement!: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.isExpanded && !this.tooltipElement) {
      // Check if not expanded and tooltip not already shown
      this.showTooltip();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltipElement) {
      this.hideTooltip();
    }
  }

  private showTooltip() {
    this.tooltipElement = this.renderer.createElement('div');
    this.tooltipElement.textContent = this.tooltipText;
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'background-color', '#293240'); // Customize background color
    this.renderer.setStyle(this.tooltipElement, 'color', 'white'); // Customize text color
    this.renderer.setStyle(this.tooltipElement, 'padding', '5px');
    this.renderer.setStyle(this.tooltipElement, 'border-radius', '5px');
    this.renderer.setStyle(
      this.tooltipElement,
      'border-top-right-radius',
      '1rem'
    );
    this.renderer.setStyle(
      this.tooltipElement,
      'border-bottom-right-radius',
      '1rem'
    );

    this.renderer.setStyle(this.tooltipElement, 'z-index', '9999'); // Ensure it's on top
    this.renderer.appendChild(document.body, this.tooltipElement);

    const buttonRect = this.el.nativeElement.getBoundingClientRect();
    const buttonRight = buttonRect.right; // Adjust the offset as needed
    const buttonTop = buttonRect.top + 10;

    this.renderer.setStyle(this.tooltipElement, 'position', 'fixed');
    this.renderer.setStyle(this.tooltipElement, 'top', `${buttonTop}px`);
    this.renderer.setStyle(this.tooltipElement, 'left', `${buttonRight}px`);
  }

  private hideTooltip() {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null!;
    }
  }
}
